import { FC } from 'react';
import { Box } from '@chakra-ui/react';

export interface DonorMessageProps {
  giftId: number; // Not displayed, used for key when parent container list binds to this child
  name: string;
  age: string;
  message: string;
}
/**
 *
 * @param props
 * @property giftId number
 * @property name  string
 * @property age  string
 * @property message string
 */
export const DonorMessage: FC<Partial<DonorMessageProps>> = (props) => {
  const { name, age, message } = props;
  return (
    <Box>
      <Box>{name} said:</Box>
      <Box fontWeight="bold">"{message}"</Box>
      <Box>{age}</Box>
    </Box>
  );
};
